<template>
  <div class="suspensionNotice-container">
    <div class="suspensionNotice-title">龙岩人民医院医生停诊通知表</div>
    <template v-if="list.length">
        <div class="suspensionNotice-time">发布时间：{{date}}</div>
        <table border="1" cellspacing="0" cellpadding="0" class="suspensionNotice-list">
            <tr>
                <th width="20%">停诊日期</th><th width="20%">停诊时间</th><th width="20%">科室名称</th><th width="20%">医生姓名</th><th width="20%">医生职称</th>
            </tr>
            <tr v-for="(item,index) in list" :key="index">
                <td>{{item.suspendTimeList[0].suspendDate}}</td>
                <td>{{item.suspendTimeList[0].startTime}} - {{item.suspendTimeList[0].endTime}}</td>
                <td>{{item.office}}</td>
                <td>{{item.doctorName}}</td>
                <td>{{item.doctiorTitle}}</td>
            </tr>
        </table>
    </template>
    <template v-else>
        <div>
            暂无数据
        </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: "",
      list: [],
    };
  },
  created() {
      this.loadList();
  },
  methods: {
    loadList() {
    this.list = [];
      this.$http
        .post( this.$api.SUBSPEND_DOCTORLIST,
          { suspendFlag: "1" }
        )
        .then(res => {
            this.list = res;
            this.date = res[0].releaseTime || ""
        });
    }
  }
};
</script>

<style lang="less">
.suspensionNotice {
    &-container {
        height: 100%;
        overflow: scroll;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    &-title {
        font-size: 1rem;
        font-weight: bold;
        margin: 1rem 0;
    }
    &-time {
        font-size: 0.6rem;
    }
    &-list {
        margin: 0.6rem 0.3rem;
        tr {
            font-size: 0.7rem;
            th {
                color: #909399;
                padding: 0.1rem 0.2rem;
            }
            td {
                color: #606266;
                padding: 0.1rem 0.2rem;
            }
        }
    }
}
</style>
